import _defineProperty from "/Users/natebennett/Documents/Talus/Code/AdLib/adlib/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('hast-util-sanitize').Schema} Schema
 * @typedef {import('mdast-util-to-hast').Handlers} Handlers
 *
 * @typedef Options
 *   Configuration.
 * @property {boolean|Schema|null} [sanitize]
 *   How to sanitize the output.
 * @property {Handlers} [handlers={}]
 *   Object mapping mdast nodes to functions handling them.
 */
import { toHtml } from 'hast-util-to-html';
import { sanitize } from 'hast-util-sanitize';
import { toHast } from 'mdast-util-to-hast';
/**
 * Plugin to serialize markdown as HTML.
 *
 * @type {import('unified').Plugin<[Options?]|void[], Root, string>}
 */

export default function remarkHtml() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var options = _objectSpread({}, settings);
  /** @type {boolean|undefined} */


  var clean;

  if (typeof options.sanitize === 'boolean') {
    clean = options.sanitize;
    options.sanitize = undefined;
  }

  if (typeof clean !== 'boolean') {
    clean = true;
  }

  Object.assign(this, {
    Compiler: compiler
  });
  /**
   * @type {import('unified').CompilerFunction<Root, string>}
   */

  function compiler(node, file) {
    var hast = toHast(node, {
      allowDangerousHtml: !clean,
      handlers: options.handlers
    }); // @ts-expect-error: assume root.

    var cleanHast = clean ? sanitize(hast, options.sanitize) : hast;
    var result = toHtml( // @ts-expect-error: assume root.
    cleanHast, Object.assign({}, options, {
      allowDangerousHtml: !clean
    }));

    if (file.extname) {
      file.extname = '.html';
    } // Add an eof eol.


    return node && node.type && node.type === 'root' && result && /[^\r\n]/.test(result.charAt(result.length - 1)) ? result + '\n' : result;
  }
}